import ExamCreate from "@/controllers/exam/exam-create.js";
import store from '@/store';
import CONFIG from "@/assets/js/config.custom.js";
import axios from "axios";

export default {
  extends: ExamCreate,
  data() {
    return {
      examTypeArr: CONFIG.EXAM_TYPE,
      exam_type: "",
      acdYearArr: [],
      termArr: [],
      gradeArr: [],
      classArr: [],
      subjectArr: [],
      examData: {
        acdYearId: '',
        termId: '',
        gradeId: '',
        classId: ''
      },
      validationErrors: {}
    };
  },

  validations: {
    ...ExamCreate.validations,
    exam_type: {
      required: value => !!value || "Exam type is required",
    }
  },

  watch: {
    'examData.acdYearId': function(newVal) {
      this.academic_year = newVal ? String(newVal) : '';
      this.submitted = false;
      this.isLoading = true;
      this.examData.termId = '';
      this.examData.gradeId = '';
      this.examData.classId = '';
      this.termArr = [];
      this.gradeArr = [];
      this.classArr = [];
      this.subjectArr = [];
      this.selectedSubjects = [0];
      
      if (newVal) {
        this.getTermListByAcdYearId(newVal);
        this.getGrading(newVal);
      }
      this.isLoading = false;
    },
    'examData.termId': function() {
      this.submitted = false;
    },
    'examData.gradeId': function(newVal) {
      this.submitted = false;
      this.isLoading = true;
      
      this.examData.classId = '';
      this.classArr = [];
      this.subjectArr = [];
      this.selectedSubjects = [0];
      
      if (newVal) {
        this.getClass(newVal);
        this.getSubjects(newVal);
      }
      this.isLoading = false;
    },
    'examData.classId': function() {
      this.submitted = false;
    }
  },

  methods: {
    getCurrentPeriodList() {
      axios
      .get('score-setting/parent-acd-year')
      .then((response) => {
        if (response.data) {
          const rawData = response.data.data;
          this.acdYearArr = rawData.map(item => ({
            id: item.id,
            text: item.period_name
          }));

          //for active period auto select
          const activeId = response.data.active_acd_year_id;
          this.examData.acdYearId =
            activeId ?? this.acdYearArr?.[0]?.id ?? null;
          this.isLoading = false;
        }
      })
      .catch(this.logout);
    },

    getTermListByAcdYearId(acdYearId) {
      if (!acdYearId) return;
      axios
      .get('period/'+ acdYearId +'/term/list')
      .then((response) => {
        if (response.data && response.data.terms) {
          this.termArr = response.data.terms.map(term => ({
            id: term.id,
            text: term.term_name
          }));
        }
      })
      .catch(this.logout);
    },

    // Exclude Early Year grades (same filter as Report Card Grading)
    getGrading(academic_year) {
      if (!+academic_year) return;

      axios.get("campusGrade/listByAcdYear", {
        params: {
          acd_year_id: academic_year,
        }
      }).then(res => {
        const list = res.data?.data || res.data || [];
        this.gradeArr = list.map(grade => ({
          id: grade.id,
          text: grade.text,
        }));
      })
      .catch(this.logout);
    },

    register() {
      this.disabled = true;
      this.validationErrors = {};
      const selectedSubjectsData = this.subjectArr
        .filter(s => this.selectedSubjects.includes(s.id))
        .map(s => ({
          id: s.id,
          full_mark: s.full_mark,
          pass_mark: s.pass_mark,
          distinction_mark: s.distinction_mark
        }));

      const request = {
        academic_year: this.examData.acdYearId,
        class_id: this.prepareData(this.selectedClass, this.classArr),
        term_id: this.examData.termId,
        exam_name: this.exam_name,
        exam_start_date: this.exam_start_date,
        exam_end_date: this.exam_end_date,
        campus_grade_id: this.campusGradeId,
        campus_id: store.state.user.campus_id,
        created_id: store.state.user.id,
        subjects: selectedSubjectsData,
        exam_type: this.exam_type,
      };
      axios.post("/exam/create", request, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        this.disabled = false;
        this.isLoading = false;

        if (response.data.status == 200) {
          this.$notification.success("Exam Added Successfully", { timer: 3, position: "bottomCenter" });
          this.$router.push({ name: "examList" });
        } else if (response.data.status == 201) {
          this.$notification.error("Exam data already exists.", { timer: 3, position: "bottomCenter" });
        } else {
          this.$notification.error("Something went wrong.", { timer: 3, position: "bottomCenter" });
        }
      })
      .catch(error => {
        this.printValidationError(error.response);
        this.isLoading = false;
        this.disabled = false;
        console.log("Exam Create API Error", error);
      });
    },
  },
};
